function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { StyleSheet } from 'react-native';
import { View } from "../../../native";
import Collapsible from "../../../Collapsible";
import { useFormContext } from "../FormContext";
import { isAnyOfType } from "../../utils";

const renderProperties = (properties, {
  mapping
}) => /*#__PURE__*/React.createElement(View, mapping.propertiesContainer, properties.map((element, index) => /*#__PURE__*/React.createElement(View, _extends({
  key: index
}, mapping.fieldContainer, {
  style: [mapping.fieldContainer.style, styles.element]
}), element.content)));

const ObjectFieldTemplate = ({
  description,
  title,
  properties,
  uiSchema,
  formContext,
  TitleField,
  DescriptionField,
  schema,
  idSchema
}) => {
  var _uiSchema$uiTitle;

  const {
    mapping
  } = useFormContext(formContext);
  const [state, setState] = React.useState({
    collapsed: false
  });
  const anyOfType = isAnyOfType(schema);
  const renderedProperties = renderProperties(properties, {
    formContext,
    mapping,
    schema,
    // @ts-ignore
    TitleField
  }); // const isRoot = (idSchema.$id === 'root')

  const hasTitle = !!title;
  const Container = View;
  return anyOfType ? renderedProperties : /*#__PURE__*/React.createElement(Container, _extends({}, mapping.fieldContainer, {
    style: [{
      paddingLeft: hasTitle ? 5 : 0
    }, mapping.fieldContainer.style]
  }), ((_uiSchema$uiTitle = uiSchema['ui:title']) !== null && _uiSchema$uiTitle !== void 0 ? _uiSchema$uiTitle : title) && /*#__PURE__*/React.createElement(TitleField, {
    title: title // required={required}
    // @ts-ignore
    ,
    formContext: formContext,
    titleOptions: mapping.objectTitle,
    icon: [_objectSpread(_objectSpread({}, mapping[`${state.collapsed ? 'down' : 'up'}Icon`]), {}, {
      onPress: () => setState({
        collapsed: !state.collapsed
      })
    })]
  }), description && /*#__PURE__*/React.createElement(DescriptionField, {
    description: description // @ts-ignore
    ,
    formContext: formContext,
    descriptionOptions: mapping.objectDescription
  }), /*#__PURE__*/React.createElement(Collapsible, {
    collapsed: state.collapsed
  }, renderedProperties));
};

const styles = StyleSheet.create({
  element: {}
});
export default ObjectFieldTemplate;